// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__xIIUY","input":"Input_input__K43GK"};